import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AppUtility } from '../utils/utility';

@Injectable()
export class DynamicDialogService {
   private _listners = new BehaviorSubject({});
   functionArg = {};

   constructor(private appUtility: AppUtility) { }

   listen(): Observable<any> {
      return this._listners.asObservable();
   }

   resetFnArguments() {
      this.functionArg = {
         uri: '', id: '', title: '', height: '', width: '', target: '', print: '', iframe: '',
         copyRightText: '', fdBck: '', prnt: '', auiButtonText: '', isCpyRigthText: '', showHeader: '', loadingText: '',
         doesLightboxOverridePageutility: '', cssClass: ''
      };
   }

   triggerLightbox(event) {
      // do nothing as the implementation moved into invokeLightbox method
   }

   invokeLightbox(event) {
      let clickedEle = (event.target || event.srcElement) as HTMLElement;
      if (clickedEle.nodeName !== 'A') {
         clickedEle = this.appUtility.findClosest(clickedEle, 'BY_ATTRIBUTE', 'onclick');
      }
      let checkFnValue, getOnclickAttr;
      if (clickedEle && clickedEle.hasAttribute('onclick')) {
         getOnclickAttr = clickedEle.getAttribute('onclick');
         if (getOnclickAttr.indexOf('showLightboxForTag') !== -1) {
            checkFnValue = new RegExp(/showLightboxForTag\((.*\)?)\)/, 'ig');
            this.getFnArguments(checkFnValue, getOnclickAttr, event);
         } else if (getOnclickAttr.indexOf('showLightbox') !== -1) {
            checkFnValue = new RegExp(/showLightbox\((.*\)?)\)/, 'ig');
            this.getFnArguments(checkFnValue, getOnclickAttr, event);
         } else if (getOnclickAttr.indexOf('showIntranetAlert') !== -1) {
            checkFnValue = new RegExp(/showIntranetAlert\((.*?)\);/, 'ig');
            this.getBPOLightboxArguments(checkFnValue, getOnclickAttr, event);
         }
      }
   }

   getFnArguments(data, getOnclickAttr, event) {
      let extractArguments, functionArgKeys;
      extractArguments = data.exec(getOnclickAttr);
      this.resetFnArguments();
      functionArgKeys = Object.keys(this.functionArg);
      extractArguments[1].split(',').forEach((node, index) => {
         this.functionArg[functionArgKeys[index]] = node.replace(/['|"]/ig, '');
      });
      this._listners.next([this.functionArg, event]);
   }

   getBPOLightboxArguments(data, getOnclickAttr, event) {
      let extractArguments, functionArgKeys;
      extractArguments = data.exec(getOnclickAttr);
      this.resetFnArguments();
      functionArgKeys = Object.keys(this.functionArg);
      extractArguments[1].split('),').forEach((node, index) => {
         // Added the below condition to execute the decodeURIComponent fn
         if (node.indexOf('decodeURIComponent') !== -1) {
            node = decodeURIComponent(node.match(/decodeURIComponent\((.*)/)[1]);
         }
         if (index === 0) {
            this.functionArg[functionArgKeys[0]] = node.replace(/['|"]/ig, '');
         } else if (index === 1) {
            this.functionArg[functionArgKeys[2]] = node.replace(/['|"]/ig, '');
         } else if (index === 2) {
            this.functionArg[functionArgKeys[11]] = node.replace(/['|"]/ig, '');
         }
      });
      this._listners.next([this.functionArg, event]);
   }
}
